import region from './region';

export default {
	regionPage: region
}